<script>
import Main from './main.vue';

export default Main.extend({
  computed: {
    seriesData() {
      return this.graphicsData.map((line, ind) => {
        const industryItem = this.$store.state.dictionaries.industry.find((el) => el.ID === line.Id);
        const data = line.KpiData[0];
        return {
          name: `${industryItem.Name}`,
          data: [{
            x: ind,
            y: data.Rating,
            qa: {
              score: data.Rating,
              level: data.QualityLevel,
            },
            reports: data.ErrorItemStatisticsData.Total,
          }],
        };
      });
    },
  },
});
</script>
